import { useEffect } from 'react';

import { StorefrontCardView } from '@zola/svc-marketplace-ts-types';

import {
  trackProductListViewed2,
  TrackingProductLocation,
  mapVendorCardToProduct,
} from '~/util/trackingHelper';

export const useTrackTopPicks = ({ topPicks }: { topPicks: StorefrontCardView[] }) => {
  useEffect(() => {
    if (topPicks?.length > 0) {
      trackProductListViewed2({
        location: TrackingProductLocation.SEARCH_RESULTS_TOP_PICKS,
        products: topPicks.map((vendor, index) => mapVendorCardToProduct(vendor, index + 1)),
      });
    }
  }, [topPicks]);
};
